import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({
  user,
  redirectPath = "/kla/intro",
  requireAdmin = false,
  children,
}) {
  if (!user) {
    alert("로그인이 필요합니다.");
    return <Navigate to={redirectPath} replace />;
  }
  if (requireAdmin && user.role !== "admin") {
    alert("관리자 권한이 필요합니다.");
    return <Navigate to="/" replace />;
  }
  return children;
}

export default ProtectedRoute;
